export default {"src":"/_next/static/media/KGC.61eddeb2.svg","height":18,"width":18};